import React, { Component } from 'react'
import { Grid, IconButton, Button, Box} from '@material-ui/core'
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import {ReactComponent as ArrowLeft} from '../../assets/ArrowLeft.svg'
import {ReactComponent as Logo} from '../../assets/LogoExample.svg'
import { withStyles } from '@material-ui/core/styles'
import useStyles from './styles/HeaderStyle'
import { openLinkInSameTab } from '../../services/Utils'

class Header extends Component {

  renderNavigationCategories() {
    const classes = this.props.classes
    return (
      <Grid item className={classes.navigationCategoriesContainer}>
        <TableContainer className={classes.navigationCategoriesContainer} style={{ overflowX: 'scroll'}}>
          <Table>
            <TableHead>
              <TableRow>
                {this.props.navigationCategories.map((link, index) =>
                  <TableCell key={index} className={classes.linkItemContainer}>
                    <Button className={`${classes.linksButton} header-link`} onClick={() => {openLinkInSameTab(link.link)}} >
                      <Box className={`${classes.linkText} header-link`}>
                        {link.name}
                      </Box>
                    </Button>
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>
      </Grid>
    )
  }

  render() {
    const classes = this.props.classes
    return (
      <Grid container direction='row' className={`${classes.headerContainer} header-container`}>
          <Grid item className={`${classes.backButton} header-back-button`}>
            <IconButton onClick={()=>{window.history.back()}}>
              <ArrowLeft className={classes.backArrow}/>
            </IconButton>
          </Grid>
          <Grid item className={`${classes.logoContainer} header-logo`} >
            <Button className={`${classes.logoButton} header-logo`} onClick={()=>{openLinkInSameTab(this.props.targetUrl)}}>
              <Logo className={`${classes.logo} header-logo`}/>
            </Button>
        </Grid>
        {this.props.navigationCategories && this.renderNavigationCategories()}
      </Grid>
    )
  }
}

export default withStyles(useStyles)(Header)
